export default __webpack_public_path__ + "static/media/T31.6d03c78e.JPG";